import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { withLocalize } from 'react-localize-redux'
import { IconButton, ListItemIcon, ListItemText, MenuItem, MenuList, } from '@material-ui/core'
import { Avatar } from 'containers'
import { getLocale, setLocale } from 'utils/localstorage'
import { compose } from 'redux'
import { connect } from 'react-redux'
import useTeamFeature from 'hooks/useTeamFeature'
import MenuItems from '../../MenuItems'
import LanguageToggle from './components/LanguageToggle'
import { StyledMenu } from './styledComponents'
import { CLUB_SUBSCRIPTION_ROUTE } from 'constants/routes'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const TopNavTeamDropdown = ({ team, currentClub }) => {
  const { enabled: billingEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.display_billing
  )

  const canManageBilling = billingEnabled && currentClub.can.includes('manage-billing')
  const preparedMenuItems = useMemo(() => {
    return MenuItems.map((item) => {
      if (item.linkTo === CLUB_SUBSCRIPTION_ROUTE && !canManageBilling) {
        return null
      }

      if (item.linkTo === CLUB_SUBSCRIPTION_ROUTE) {
        return {
          ...item,
          linkTo: CLUB_SUBSCRIPTION_ROUTE.populateURLParams({ clubUuid: currentClub.uuid })
        }
      }

      return item
    }).filter(Boolean) // exclude NULL
  }, [MenuItems, currentClub])

  setLocale(getLocale())
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleMenuOpenClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      {team && (
        <IconButton size="medium" onClick={handleMenuOpenClick}>
          <Avatar
            src={`${team.relationships.logo?.full_url}`}
            alt={team.name}
          />
        </IconButton>
      )}

      <StyledMenu
        id="Profile-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <LanguageToggle />
        {preparedMenuItems.map(
          ({ LinkComponent, linkTo, icon, text, divider, target }) =>
            <MenuList key={linkTo}>
              {divider}
              <MenuItem
                button
                onClick={handleClose}
                component={LinkComponent}
                to={linkTo}
                target={target}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={text} />
              </MenuItem>
            </MenuList>
        )}
      </StyledMenu>
    </>
  )
}

TopNavTeamDropdown.propTypes = {
  team: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    relationships: PropTypes.shape({
      logo: PropTypes.shape({
        full_url: PropTypes.string,
      }),
    }),
    can: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  currentClub: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    can: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
}

export default compose(
  connect(({ team, clubs }) => ({
    team,
    currentClub: clubs.current,
  })),
  withLocalize,
)(TopNavTeamDropdown)
